import styles from './Terms.module.css';

const sections = [
    { title: 'Acceptance of Terms', body: 'By using Aluvo, you agree to these Terms of Service. If you do not agree, please do not use the platform.' },
    { title: 'Age Requirement', body: 'You must be at least 13 years old to create an account and use Aluvo. By registering, you confirm that you meet this minimum age requirement. If we discover that a user is under 13, we will immediately terminate their account in compliance with applicable laws.' },
    { title: 'Your Account', body: 'You are responsible for maintaining the confidentiality of your account. You must not use another person\'s account without permission.' },
    { title: 'Content', body: 'You retain ownership of content you create. By posting on Aluvo, you grant us a license to display that content on the platform.' },
    { title: 'Quiz & Badges', body: 'Coin badges are earned through our quiz system and are non-transferable. Aluvo reserves the right to revoke badges in cases of cheating or abuse.' },
    { title: 'Prohibited Conduct', body: 'You may not use Aluvo to harass others, spread misinformation, or attempt to reverse-engineer our systems.' },
    { title: 'Termination', body: 'We reserve the right to suspend or terminate accounts that violate these terms.' },
    { title: 'Changes', body: 'We may update these terms at any time. Continued use of Aluvo after changes constitutes acceptance.' },
    { title: 'Contact', body: 'Questions? Reach us at legal@aluvo.app' },
];

function Terms() {
    return (
        <main className={styles.page}>
            <div className={`container ${styles.inner}`}>
                <h1 className={styles.title}>Terms of Service</h1>
                <p className={styles.updated}>Last updated: May 2026</p>
                {sections.map((s) => (
                    <section key={s.title} className={styles.section}>
                        <h2>{s.title}</h2>
                        <p>{s.body}</p>
                    </section>
                ))}
            </div>
        </main>
    );
}

export default Terms;